import { render, staticRenderFns } from "./process-purpose-form.vue?vue&type=template&id=92d2cfe8"
import script from "./process-purpose-form.vue?vue&type=script&lang=js"
export * from "./process-purpose-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports